import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { FlexLayout, SaltIcons, StackLayout } from "@/design-system/salt";

/** Account Pending Approval component. */
export default function AccountPendingApproval() {
  const { signOut } = useAuth();

  return (
    <FlexLayout align="center" justify="center" style={{minHeight: "100vh", background: "var(--salt-container-primary-background)", padding: "var(--salt-spacing-200)"}}>
      <StackLayout gap={3} direction="column" style={{maxWidth: "28rem", width: "100%", textAlign: "center"}}>
        <SaltIcons.ClockIcon aria-hidden="true" style={{marginLeft: "auto", marginRight: "auto"}} size={2} />
        <StackLayout gap={1} direction="column">
          <h1 style={{fontSize: "1.5rem", fontWeight: 600, color: "var(--salt-content-primary-foreground)"}}>Account Pending Approval</h1>
          <p style={{color: "var(--salt-content-secondary-foreground)"}}>
            Your account has been created and is awaiting approval from a platform administrator.
            You'll receive an email once your account is activated.
          </p>
        </StackLayout>
        <Button variant="outline" onClick={signOut} type="button">
          Sign Out
        </Button>
      </StackLayout>
    </FlexLayout>
  );
}
